import React from "react";
import clsx from "clsx";

export default function PSGrid({ children, mobileCarousel = false, large = false }) {
  return (
    <>
      <div 
        className={clsx(
        "grid grid-cols-2 gap-4 my-4",
        large ? "lg:grid-cols-2" : "lg:grid-cols-3"
      )}>

        {children}
      </div>
    </>
  );
}